import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import "../../i18n";
import { useTranslation } from "react-i18next";
import { mailIcon, mailIconL, mainIcon } from "../../assets/";

const Contact = () => {
  const { t, i18n } = useTranslation();

  const [isLightMode, setIsLightMode] = useState(false);

  const updateTheme = () => {
    const currentTheme = document.documentElement.getAttribute("data-theme");
    setIsLightMode(currentTheme === "light");
  };

  useEffect(() => {
    updateTheme();

    const observer = new MutationObserver(() => {
      updateTheme();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Message: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_cu4mmb7",
        "template_ciwz4o8",
        {
          Name: formData.Name,
          Email: formData.Email,
          Message: formData.Message,
        },
        "P83caJsAKuQj-k3MN"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setIsSubmitted(true);
          setFormData({ Name: "", Email: "", Message: "" });
        },
        (error) => {
          console.error("FAILED...", error);
          setError(t("errorMessage"));
        }
      );
  };

  return (
    <div className="contact" id="contact">
      <div className="wrapper">
        <div className="name">
          <p>{t("contact")}</p>
        </div>
        <div className="main-contact">
          {}
          {isSubmitted ? (
            <div className="success-message">
              <img
                src={isLightMode ? mailIconL : mailIcon}
                alt="mailIcon"
                className="mailIcon"
              />
              <p>{t("successMessage")}</p>
            </div>
          ) : (
            <div>
              <div className="contact-description">
                <p className="contact-description-text">
                  {t("contactDescription")}
                </p>
              </div>
              <form className="contact-form" onSubmit={sendEmail}>
                <div className="contact-form-first">
                  <div className="contact-form-name">
                    <div className="input-group">
                      <input
                        autoComplete="off"
                        name="Name"
                        id="Name"
                        placeholder={t("contactName")}
                        className="inputNameandEmail"
                        type="text"
                        value={formData.Name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="contact-form-email">
                    <input
                      autoComplete="off"
                      name="Email"
                      id="Email"
                      placeholder={t("contactEmail")}
                      className="inputNameandEmail"
                      type="email"
                      value={formData.Email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="contact-form-message">
                  <textarea
                    autoComplete="off"
                    name="Message"
                    id="Message"
                    placeholder={t("contactMessage")}
                    className="inputMessage"
                    value={formData.Message}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="contact-form-send">
                  <button className="button-send" type="submit">
                    <div className="svg-wrapper-1">
                      <div className="svg-wrapper">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                        >
                          <path fill="none" d="M0 0h24v24H0z"></path>
                          <path
                            fill="currentColor"
                            d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <span className="send-button">{t("send")}</span>
                  </button>
                </div>
              </form>
            </div>
          )}
          {error && (
            <div className="error-message">
              <p>{t("errorMessage")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
